import { Dropdown } from "@/atoms-react/dropdown/index.react";
import { Base } from "@/atoms-react/text/Text.react";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { setTheme, getTheme } from "@/features/utils/theme.ts";

export const ThemeSelector = () => {
  const { t } = useTranslation(["pass"]);

  const themes = {
    light: t("olkypass.securityPage.settingsSection.themes.option.light"),
    dark: t("olkypass.securityPage.settingsSection.themes.option.dark")
  };
  return (
    <Dropdown
      className={"inline-block w-full max-w-48"}
      items={Object.entries(themes).map(([key, value]) => ({
        key,
        value,
        render: ({ key, value }) => (
          <Fragment key={key}>
            <div className={"flex w-full max-w-48 items-center justify-between"}>
              <Base>{value}</Base>
            </div>
          </Fragment>
        )
      }))}
      showChevrons
      value={getTheme()}
      onChange={({ key }) => setTheme(key)}
    />
  );
};
